<template>
  <div>
    <el-container direction="vertical">
      <el-main>
        <el-row :gutter="20">
          <el-col :span="8" :xs="8" :sm="24" :md="24" :lg="8">
            <el-form-item
              label="Tipo Documento "
              style="font-weight: bold; padding-right: 10px; padding-left: 10px"
              id="filtro"
              name="document"
            >
              <el-select
                v-model="valSelectType"
                clearable
                filterable
                reserve-keyword
                remote
                placeholder="Seleccionar aquí"
              >
                <el-option
                  v-for="(item, index) in typeOption"
                  :key="index"
                  :label="item.value"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Desde" id="datesFields" hidden>
              <el-input
                v-model="fromDate"
                hidden
                type="date"
                id="from"
                name="from"
              />
            </el-form-item>
          </el-col>

          <el-col :span="8" :xs="8" :sm="16" :md="16" :lg="8">
            <el-form-item
              label="Fecha Estado de Cuenta"
              style="font-weight: bold"
              id="filterDate"
              name="filterDate"
              label-width="170px"
            >
              <el-select
                v-model="valSelect"
                clearable
                filterable
                reserve-keyword
                remote
                placeholder="Seleccionar aquí"
                @change="showHideDatesInputs"
              >
                <el-option
                  v-for="(item, index) in dateOption"
                  :key="index"
                  :label="item.value"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Hasta" id="datesFields2" hidden>
              <el-input v-model="fromTo" hidden type="date" id="to" name="to" />
            </el-form-item>
          </el-col>

          <a
            href="#"
            @click="createPDF"
            class="el-button el-button--primary el-button--mini"
            style="margin-left: 5px; z-index: 100"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              class="bi bi-file-earmark-arrow-down-fill"
              viewBox="0 0 16 16"
            >
              <path
                d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zm-1 4v3.793l1.146-1.147a.5.5 0 0 1 .708.708l-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 0 1 .708-.708L7.5 11.293V7.5a.5.5 0 0 1 1 0z"
              ></path>
            </svg>
            Generar movimientos
          </a>
        </el-row>
      </el-main>
    </el-container>

    <div class="text-right">
      <p>
        Saldo Pendiente :
        <span class="label label-danger" style="font-size: 22px">
          <template> RD </template>

          <el-tag
            type="danger"
            effect="dark"
            v-if="PendingBalanceRD"
            style="font-size: 22px; color: white"
            >{{ PendingBalanceRD }}</el-tag
          >
          <el-tag
            type="danger"
            effect="dark"
            v-else
            style="font-size: 22px; color: white"
            >0.00</el-tag
          >
        </span>
      </p>
    </div>

    <div class="text-right">
      <p>
        Saldo Pendiente :
        <span class="label label-danger" style="font-size: 22px">
          <template> USD </template>
          <el-tag
            type="danger"
            effect="dark"
            v-if="PendingBalanceUSD"
            style="font-size: 22px; color: white"
            >{{ PendingBalanceUSD }}</el-tag
          >
          <el-tag
            type="danger"
            effect="dark"
            v-else
            style="font-size: 22px; color: white"
            >0.00</el-tag
          >
        </span>
      </p>
    </div>

    <div class="table-box card-base card-shadow--medium">
      <rabbey-table3
        style="width: 100%"
        ref="table"
        :data="items"
        :border="true"
        :fit="true"
        :stripe="true"
        :lazy="true"
        v-loading="loading"
        :summary-method="getSummaries"
        :row-class-name="tableRowClassName"
        show-summary
        :columns="columns"
        :actions="actions"
        @rtable-push-action="HandlerAction"
        max-height="600"
      >
        <!--
        <el-table-column
          width="50"
          fixed
          align="center"
          v-if="actions !== undefined"
        >
          <template slot="header" slot-scope="scope">
            <i class="el-icon-setting" :key="scope.$index"></i>
          </template>
          <template slot-scope="scope">
            <el-dropdown trigger="click" @command="handleCommand">
              <span class="el-dropdown-link">
                <i class="mdi mdi-menu"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <template v-for="(action, index) in actions">
                  <el-dropdown-item
                    v-if="
                      action.condition !== undefined &&
                      typeof action.condition === 'function'
                        ? action.condition(scope.row)
                        : true
                    "
                    :key="index"
                    :command="{
                      index: scope.$index,
                      row: scope.row,
                      column: scope.column,
                      command: action.command
                    }"
                    :icon="action.icon"
                    >{{ action.label }}</el-dropdown-item
                  >
                </template>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>

        <el-table-column
          v-for="(column, index) in columns"
          :key="index"
          v-bind="column"
          :formatter="
            typeof column.formatter === 'function' ? column.formatter : null
          "
        >
          <template
            #default="{ row }"
            v-if="typeof column.formatter !== 'function'"
          >
            <div
              v-if="column.formatter"
              :is="column.formatter"
              v-bind="{
                row: row,
                column: column.prop,
                ...column.cellAtrrs
              }"
            ></div>
            <template v-else>
              {{ row[column.prop] }}
            </template>
          </template>
        </el-table-column>
        -->
      </rabbey-table3>

      <el-drawer
        title="Cambio de fecha de pago"
        :append-to-body="true"
        :before-close="handleClose"
        :visible.sync="formpayment"
        size="25%"
      >
        <hr />
        <el-container>
          <el-main>
            <el-row>
              <el-col>
                <el-form
                  ref="form"
                  label-width="120px"
                  v-model="form"
                  label-position="top"
                >
                  <el-form-item label="Contacto">
                    <el-select
                      v-model="form.contactName"
                      v-loading="loadingContacts"
                      placeholder="Contactos"
                      style="width: 100%"
                      @change="handleContactSelect"
                    >
                      <el-option
                        style="width: 100%"
                        v-for="item in contacts"
                        :key="item.Code"
                        :label="item.FullName"
                        :value="item"
                      ></el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item label="Teléfono">
                    <el-input
                      placeholder="Teléfono"
                      v-model="form.contactNumber"
                      style="width: 100%"
                      disabled
                    ></el-input>
                  </el-form-item>

                  <el-form-item label="Celular">
                    <el-input
                      placeholder="Celular"
                      v-model="form.contactPhoneNumber"
                      style="width: 100%"
                      disabled
                    ></el-input>
                  </el-form-item>

                  <el-form-item label="Correo">
                    <el-input
                      placeholder="Correo"
                      v-model="form.contactEmail"
                      style="width: 100%"
                      disabled
                    ></el-input>
                  </el-form-item>

                  <el-form-item label="Fecha de Pago">
                    <el-date-picker
                      type="date"
                      placeholder="Fecha Original"
                      v-model="form.currentdate"
                      disabled
                      style="width: 100%"
                    ></el-date-picker>
                  </el-form-item>

                  <el-form-item label="Nueva Fecha Promesa de Pago">
                    <el-date-picker
                      type="date"
                      placeholder="Nueva Fecha"
                      v-model="form.newdate"
                      style="width: 100%"
                    ></el-date-picker>
                  </el-form-item>

                  <el-form-item label="Motivo de Promesa de Pago">
                    <el-input
                      type="textarea"
                      :rows="4"
                      placeholder="Comentario"
                      v-model="form.comment"
                      style="width: 100%"
                    ></el-input>
                  </el-form-item>

                  <el-form-item>
                    <el-button
                      type="primary"
                      :loading="handleButtonLoading"
                      :disabled="!isValid"
                      size="mini"
                      @click="onSubmit"
                      >Guardar cambios</el-button
                    >
                    <el-button @click="handleClose" size="mini"
                      >Cancelar</el-button
                    >
                  </el-form-item>
                </el-form>
              </el-col>
            </el-row>
          </el-main>
        </el-container>
      </el-drawer>
    </div>
  </div>
</template>

<script>
import { formatDate, formatterMoney } from "@/utils";
import DownLoadFile from "@/components/functionals/DownloadFileAccountState.vue";
import ReportAccountStatusDocumentType from "@/components/functionals/ReportAccountStatusDocumentType.vue";
import ReportAccountStatusImportRemain from "@/components/functionals/ReportAccountStatusImportRemain.vue";
import ReportAccountStatusImportRemainRD from "@/components/functionals/ReportAccountStatusImportRemainRD.vue";
import DatetimeFormatter from "@/components/functionals/DatetimeFormatter.vue";
//import DropDownMenu from "@/components/functionals/DropDownMenu.vue";

export default {
  name: "TableAccountStatus",
  props: ["clientCode"],
  data() {
    return {
      fromDate: "",
      fromTo: "",
      valSelectType: "",
      valSelect: "",
      loading: false,
      currency: "",
      import_remain: "",
      contacts: [],
      AccountNumber: "",
      Amount: "",
      InvoiceNum: "",
      ContactEmail: "",
      formpayment: false,
      selectedRow: {},
      loadingContacts: false,
      handleButtonLoading: false,
      PendingBalanceRD: 0.0,
      PendingBalanceUSD: 0.0,
      form: {
        currentdate: "",
        newdate: "",
        comment: "",
        contactName: "",
        contactData: "",
        contactEmail: "",
        contactNumber: "",
        contactPhoneNumber: ""
      },
      items: [],
      actions: [
        {
          icon: "el-icon-date",
          label: "Cambiar fecha de pago",
          command: "change-date-payment",
          condition: ""
        }
        /*
        {
          icon: "el-icon-chat-line-square",
          label: "Ver comentario",
          command: "see-comments"
        }
        */
      ],
      columns: [
        /*
        {
          label: "Menu",
          fixed: true,
          align: "center",
          formatter: DropDownMenu
        },
        */
        {
          prop: "nameFile", // filtrar que solo el boton salga en facturas
          label: "Descargar",
          width: 150,
          sortable: false,
          formatter: DownLoadFile
        },
        {
          prop: "PostDate",
          label: "Fecha de registro",
          formatter: DatetimeFormatter,
          width: 180,
          sortable: true
        },
        {
          prop: "DocumenType",
          label: "Tipo de documento",
          width: 200,
          aling: "center",
          formatter: ReportAccountStatusDocumentType
        },
        {
          prop: "InvoiceNumber",
          label: "Documento"
        },
        {
          prop: "InvoiceDescription",
          label: "Descripción"
        },
        {
          prop: "ImportIniRD",
          label: "Importe Inicial RD",
          width: 135,
          formatter: (row) => {
            return formatterMoney(row.ImportIniRD);
            // row.Moneda + " " +
          }
        },
        {
          prop: "ImportIniUSD",
          label: "Importe Inicial USD",
          width: 135,
          formatter: (row) => {
            return formatterMoney(row.ImportIniUSD);
            // row.Moneda + " " +
          }
        },
        {
          prop: "ImportRemainRD",
          label: "Importe pendiente RD",
          width: 145,
          formatter: ReportAccountStatusImportRemainRD
          /*formatter: (row) => {
            return row.Moneda + " " + formatterMoney(row.ImportRemain);
          }*/
        },
        {
          prop: "ImportRemainUSD",
          label: "Importe pendiente USD",
          width: 145,
          formatter: ReportAccountStatusImportRemain
          /*formatter: (row) => {
            return row.Moneda + " " + formatterMoney(row.ImportRemain);
          }*/
        },
        {
          prop: "ExpirationDate",
          label: "Fecha de vencimiento",
          formatter: DatetimeFormatter,
          width: 180
        }
      ],
      dateOption: [
        { id: 1, value: "Ultimo mes" },
        { id: 2, value: "Ultimo dos meses" },
        { id: 3, value: "Ultimo tre meses" },
        { id: 6, value: "Ultimo seis meses" },
        { id: "fromto", value: "Rango de fecha" }
      ],
      typeOption: [
        { id: "Todos", value: "Todos" },
        { id: "Factura", value: "Factura" },
        { id: "Nota de crédito", value: "Nota de crédito" },
        { id: "Pago", value: "Pago" }
      ]
    };
  },
  created() {
    this.getItems();
  },
  computed: {
    isValid: function () {
      return this.form.comment.trim().length > 5 && this.form.newdate !== null;
    }
  },
  methods: {
    formatDate,
    formatterMoney,

    getItems() {
      this.loading = true;
      this.items = [];
      this.$http
        .get("/api/invoices/accountStatusWithUsd", {
          timeout: 3 * 60 * 1000, // Espera hasta 3 minutos
          params: {
            "criteria.clientCode": this.clientCode,
            "criteria.companyCode": this.currentCompany,
            "criteria.opc": 1
          }
        })
        .then(({ data }) => {
          this.PendingBalanceRD = formatterMoney(data.PendingBalanceRD);
          this.PendingBalanceUSD = formatterMoney(data.PendingBalanceUSD);
          this.items = data.InvoiceList;
        })
        .catch((error) => {
          this.$message.error("Error al consultar el estado de cuenta");
          console.error(error);
          this.items = [];
        })
        .finally(() => {
          this.loading = false;
          this.$refs.table.doLayout();
        });
    },
    // eslint-disable-next-line
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex === 1) {
        return "warning-row";
      } else if (rowIndex === 3) {
        return "success-row";
      }
      return "";
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "Saldo Pendiente";
          return;
        }

        try {
          const currency = data
            .map((item) => item.Moneda)
            .filter((currency) => currency.length > 0)[0];
          this.currency = currency;
        } catch (_) {
          //
        }

        if (index === 6) {
          const values = data.map((item) => Number(item[column.property]));

          if (!values.every((value) => isNaN(value))) {
            let result = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);

            result = formatterMoney(result);
            sums[index] = result;
            this.import_remain = result;
          } else {
            sums[index] = "N/A";
          }
        }
      });

      return sums;
    },
    showHideDatesInputs() {
      if (this.valSelect == "fromto") {
        document.getElementById("datesFields").removeAttribute("hidden");
        document.getElementById("datesFields2").removeAttribute("hidden");
      } else {
        document.getElementById("datesFields").setAttribute("hidden", "hidden");
        document
          .getElementById("datesFields2")
          .setAttribute("hidden", "hidden");
      }
    },
    createPDF() {
      //var url = '/api/invoices/MakeAccountStatus/?filterDate=' + this.valSelect + '&docType=' + this.valSelectType + '&fromDate=' + this.fromDate + '&toDate=' + this.fromTo;
      var url = "/api/invoices/MakeAccountStatus/";
      this.loading = true;
      this.items = [];
      this.$http
        .get(url, {
          timeout: 3 * 60 * 1000, // Espera hasta 3 minutos
          params: {
            ClientCode: this.clientCode,
            CompanyCode: this.currentCompany,
            filterDate: this.valSelect,
            docType: this.valSelectType,
            fromDate: this.fromDate,
            toDate: this.fromTo
          }
        })
        .then(({ data }) => {
          var myWindow = window.open(
            this.href,
            "child",
            "height=" + screen.height + ",width=" + screen.width + ",fullscreen"
          );
          myWindow.document.write(
            "<object data='data:application/pdf;base64," +
              data.FileContents +
              "' width='100%' height='100%' type='application/pdf'></object>"
          );
        })
        .catch((error) => {
          this.$message.error("Error al consultar el estado de cuenta");
          console.error(error);
          this.items = [];
        })
        .finally(() => {
          this.loading = false;
          //this.$refs.table.doLayout();
        });
    },
    onSubmit() {
      this.handleButtonLoading = true;
      var data = {
        OldDate: this.form.currentdate,
        PromiseDate: this.form.newdate,
        CustomerCode: this.AccountNumber,
        Amount: this.Amount,
        Motive: this.form.comment,
        CompanyID: this.currentCompany,
        User: this.currentUser.FullName,
        InvoiceNum: this.invoiceNum,
        ContactName: this.form.contactData.FullName,
        ContactEmail: this.form.contactData.Email,
        ContactNumber: this.form.contactData.PhoneNumber,
        ContactCode: this.form.contactData.Code,
        SalesPersonCode: this.currentUser.PersonCode,
        CustomerServiceExec_: this.currentUser.CustomerServiceExec_
      };
      this.$http
        .post("/api/AccountsReceivable/ChangeDataFromDueDateToFutureDate", data)
        .then(({ data }) => {
          if (data) {
            this.formpayment = false;
            if (data.AddInteraction) {
              let msg =
                "Se ha creado una interacion con este compromiso de pago";
              setTimeout(() => {
                this.$notify.success({
                  duration: 9000,
                  message: msg,
                  title: "Creacion de Interacion",
                  position: "top-left"
                });
              }, 1500);
            }
            if (data.NotifyCustomer) {
              let msg = "El contacto ha sido notificado via correo";
              setTimeout(() => {
                this.$notify.success({
                  duration: 9000,
                  message: msg,
                  offset: 10,
                  title: "Notificacion a cliente",
                  position: "top-left"
                });
              }, 1500);
            }
            if (data.CashFlowModify) {
              let msg =
                "Se ha creado un movimiento en cashflow con este compromiso";
              setTimeout(() => {
                this.$notify.success({
                  duration: 9000,
                  message: msg,
                  offset: 20,
                  title: "Registro en cashflow",
                  position: "top-left"
                });
              }, 1500);
            }
          }
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.handleButtonLoading = false;
          this.getItems();
          this.handleClose();
        });
    },
    HandlerAction(action) {
      const { command } = action;
      const { ClientCode, PostDate, InvoiceNumber } = action.row;

      this.Amount = action.row.Amount;
      this.AccountNumber = ClientCode;
      this.invoiceNum = InvoiceNumber;
      this.OldDate = PostDate;

      switch (command) {
        case "change-date-payment":
          this.formpayment = true;
          this.selectedRow = action.row;
          this.form.currentdate = PostDate;
          this.getContactsByCustomerCode(ClientCode);
          break;
        case "see-comments":
          this.Dcoments = true;
          this.getcomments(ClientCode);
          break;
        default:
          break;
      }
    },
    getContactsByCustomerCode(customerCode = String) {
      this.loadingContacts = true;
      this.$http
        .get("/api/contacts/GetContactByCustomerCode", {
          params: {
            customerCode: customerCode,
            companyCode: this.currentCompany
          }
        })
        .then(({ data }) => {
          this.contacts = data;
        })
        .catch((err) => {
          this.$message.error(
            `no se pudieron tener contacto sobre este cliente ${err}`
          );
        })
        .finally(() => {
          this.loadingContacts = false;
        });
    },
    handleContactSelect(contact) {
      this.form.contactData = contact;
      this.form.contactName = contact.FullName;
      this.form.contactEmail = contact.Email;
      this.form.contactNumber = contact.MobilePhoneNumber;
      this.form.contactPhoneNumber = contact.PhoneNumber;
    },
    handleCommand(command) {
      return this.$emit("rtable-push-action", command);
    },
    handleClose() {
      this.form.currentdate = "";
      this.form.newdate = "";
      this.form.comment = "";
      this.form.contactName = "";
      this.form.contactEmail = "";
      this.form.contactNumber = "";
      this.form.contactPhoneNumber = "";
      this.AccountNumber = "";
      this.Amount = "";
      this.InvoiceNum = "";
      this.ContactEmail = "";
      this.formpayment = false;
      this.selectedRow = {};
    }
  }
};
</script>

<style lang="scss" scoped>
.tags span:not(:first-child) {
  margin-left: 5px;
}
.el-table .warning-row {
  background: red;
}

.el-table .success-row {
  background: #f0f9eb;
}
</style>
